import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    minHeight: 300,
    flexGrow: 1,
  },
  item: {
    userSelect: 'none',
    fontSize: 14,
    lineHeight: '24px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  missingItem: {
    backgroundColor: '#FBE9EB',
  },
  extraItem: {
    backgroundColor: '#ECFDF0',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
  },
  actionButton: {
    height: 22,
    margin: 0,
    borderRadius: 0,
    boxShadow: '0 0 0',
  },
  tooltip: {
    maxWidth: 400,
    marginLeft: 5,
    marginBottom: 5,
    fontSize: 12,
    fontWeight: 400,
    padding: 15,
    backgroundColor: '#FEFFDE',
    color: 'black',
    border: '1px solid black',
    '& p': {
      marginTop: 5,
    },
  },
  label: {
    display: 'flex',
    alignItems: 'center',
  },
  downloadButton: {
    height: 20,
    width: 20,
    minWidth: 20,
    margin: '2px',
  },
  downloadIcon: {
    height: 14,
  },
  crudButton: {
    padding: 0,
  },
  crudIcon: {
    height: 18,
  },
  expanded: {
    backgroundColor: '#e0e0e0!important',
  },
}));
